/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CourseSegment } from './courseSegment';

export type CourseUpdateRequestSegments = CourseSegment[] | null;
